import React from 'react';
import axios from 'axios';
import {withRouter} from "react-router-dom";
import Loading from "../../components/Loading/index";

class NewsfeedPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: this.props.match.params.id ? true : false,
            name: '',
            text: '',
            link: '',
            picturePath: null
        }
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getNewsfeed();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getNewsfeed();
        }
    }

    getNewsfeed() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.newsfeeds + "/" + this.props.match.params.id, config)
            .then((response) => {
                this.setState({
                    ...response.data,
                    loading: false
                });
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst novinku!');
                this.props.history.push('/newsfeeds');
                console.log("Axios error: ", error);
            });
        }
    }

    render () {
        let {name, text, link, picturePath} = this.state;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Náhled novinky {name}</h2>
                    <div className="clearfix"/>
                </div>
                {
                    this.state.loading ?
                        <div className="x-content">
                            <Loading/>
                        </div> :
                        <div className="x-content">
                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                <h4>Základní údaje</h4>
                                <table className="table table-striped table-responsive">
                                    <tbody>
                                    <tr>
                                        <th>Název:</th>
                                        <td>{name}</td>
                                    </tr>
                                    <tr>
                                        <th>Text:</th>
                                        <td>{text}</td>
                                    </tr>
                                    <tr>
                                        <th>Link:</th>
                                        <td>{link}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-lg-offset-1 col-md-offset-1 col-sm-offset-1">
                                <h4>Obrázek</h4>
                                {picturePath &&
                                <img className="center-block" src={`${__APIURL__}/${picturePath}`} alt="Obrázek novinky"/>}
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default withRouter(NewsfeedPreview);



/** WEBPACK FOOTER **
 ** ./src/containers/Newsfeeds/NewsfeedPreview.js
 **/